// Helpers partages du module Caisse Centrale (admin) -- extraits de NosDepenses.jsx, logique inchangee.

/**
 * Les deux boutons d'un pied de modal partagent taille ET largeur.
 *
 * Les modals du module les posaient en `flex-1` : ils s'etiraient a la largeur
 * disponible, donc differemment d'un modal a l'autre, et l'annulation pouvait
 * paraitre plus importante que la validation. Meme valeur que dans
 * `CandidatsLibresSection`, plutot qu'une variante de plus.
 */
export const BOUTON_PIED_CLASSES = 'h-9 min-w-[168px] justify-center gap-2';

/** Le gabarit commun aux quatre modals du module : large plutot que long. */
export const MODAL_CONTENT_CLASSES =
  'flex w-[95vw] flex-col gap-0 overflow-hidden p-0 !max-h-[92vh]';

export const CENTRAL_MOVEMENT_TYPES = [
  { value: 'apport', label: 'Apport central', sens: 'entree' },
  { value: 'ajustement_positif', label: 'Ajustement positif', sens: 'entree' },
  { value: 'dotation', label: 'Dotation caisse/personne', sens: 'sortie' },
  { value: 'grosse_depense', label: 'Grosse dépense', sens: 'sortie' },
  { value: 'ajustement_negatif', label: 'Ajustement négatif', sens: 'sortie' }
];

export const CENTRAL_MOVEMENT_LABELS = {
  remise_validee: 'Remise validée',
  apport: 'Apport central',
  ajustement_positif: 'Ajustement positif',
  dotation: 'Dotation',
  salaire_central: 'Salaire central',
  grosse_depense: 'Grosse dépense',
  ajustement_negatif: 'Ajustement négatif',
  annulation_remise: 'Annulation remise'
};

export const MONTH_OPTIONS = [
  { value: 1, label: 'Janvier' },
  { value: 2, label: 'Février' },
  { value: 3, label: 'Mars' },
  { value: 4, label: 'Avril' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Juin' },
  { value: 7, label: 'Juillet' },
  { value: 8, label: 'Août' },
  { value: 9, label: 'Septembre' },
  { value: 10, label: 'Octobre' },
  { value: 11, label: 'Novembre' },
  { value: 12, label: 'Décembre' }
];

export const PERIODE_OPTIONS = [
  { value: 'jour', label: "Aujourd'hui" },
  { value: 'semaine', label: 'Cette semaine' },
  { value: 'mois', label: 'Ce mois' },
  { value: 'annee', label: 'Année scolaire' }
];

export const formatMontant = (montant) => {
  return `${Math.round(montant || 0).toLocaleString('fr-FR').replace(/,/g, ' ')} FCFA`;
};

export const parseMontant = (value) => Number(String(value || '').replace(/\s/g, '').replace(',', '.')) || 0;

export const formatDateTime = (value) => {
  if (!value) return '-';
  return new Date(value).toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const getMovementTypeLabel = (type) => CENTRAL_MOVEMENT_LABELS[type] || type || 'Mouvement';

export const getDotationUsageLabel = (usage) => (usage === 'principale' ? 'Caisse principale' : 'Budget dépenses');
